import { carouselActions, recoAnalytics } from '../../utils/recoAnalytics';

const usePillsButtonMetricsHook = ({ carouselName, slotId, siteName, currentGroup, groups, products, pageId }) => {
  const onGroupClick = (group) => {
    recoAnalytics.click({
      carouselKey: 'CR_RecommendationPill',
      siteName,
      groupId: group.groupId,
      action: carouselActions.clickToRate,
      carouselName,
      pageName: pageId,
      skuId: group.rawGroupName,
      podPositionInCarousel: group.position,
      lengthPodsInCarousel: groups.length,
      slotId,
      forceSendTrack: true,
    });
  };

  const onProductClick = (product) => {
    recoAnalytics.click({
      carouselKey: 'CR_RecommendationPill',
      siteName,
      groupId: currentGroup?.groupId,
      action: carouselActions.clickToRate,
      carouselName,
      pageName: pageId,
      skuId: product.id,
      podPositionInCarousel: product.position,
      lengthPodsInCarousel: products.length,
      slotId,
    });
  };

  const onProductImpression = (product) => {
    recoAnalytics.impression({
      carouselName: `${carouselName}_${currentGroup?.groupId}`,
      skusViewed: [product?.id],
    });
  };

  return {
    groupAnalytics: {
      onClick: onGroupClick,
    },
    carouselAnalytics: {
      onProductClick,
      onProductImpression,
    },
  };
};

export { usePillsButtonMetricsHook };
